<template>
  <div class="printing-layout">
    <router-view class="view-container" />
  </div>
</template>

<script>
export default {
  name: "PrintingLayout",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/component/printing-layout.scss";
</style>